export enum SourceType {
    doc = "doc",
    docx = "docx",
    xls = "xls",
    xlsx = "xlsx",
    ppt = "ppt",
    pptx = "pptx",
    csv = "csv",
    txt = "txt",
    pdf = "pdf",
    mp3 = "mp3",
    mp4 = "mp4",
    m4a = "m4a",
    file = "file",
    video = "video"
}
